import { Box, Flex, Text } from "@chakra-ui/react";
import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import EdssResultTableForLink from "./EdssResultTableForLink";
import EdssSearchFormWithLink from "./EdssSearchFormWithLink";

const EdssSearch = ({ onClose }) => {
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, reset, setValue, watch } = useForm();
  const navigate = useNavigate();

  const previousDataRef = useRef(null);
  const onSubmit = async (data) => {
    console.log("Data has not changed. Skipping API call.", data);
    if (JSON.stringify(data) === JSON.stringify(previousDataRef.current)) {
      return;
    }
    try {
      setIsLoading(true);
      const response = await fetch("/api/searchEDSSCase", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        setIsLoading(false);
        console.log("Network response was not ok");
      }
      const result = await response.json();
      setSearchResult(result);
      // Update previous data after successful API call
      previousDataRef.current = data;
      reset();
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenCase = (ID, PersonID, data) => {
    localStorage.setItem("recentClickCase", JSON.stringify(data));
    navigate(`/CaseView/${ID}/${PersonID}`);
    onClose();
  };

  return (
    <Box minH="65vh">
      <Flex>
        <Box w="30%" borderRight="2px solid gray" pr={4}>
          <EdssSearchFormWithLink
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            isLoading={isLoading}
            setValue={setValue}
            watch={watch}
          />
        </Box>

        <Box w="69%" pl={2}>
          {searchResult?.length > 0 && !isLoading ? (
            <EdssResultTableForLink
              handleOpenCase={handleOpenCase}
              searchResult={searchResult}
              isResultLoading={isLoading}
            />
          ) : (
            <Text textAlign="center" fontSize="xl" my={5}>
              No record found
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default EdssSearch;
